const initialCaseState = {
    pharmacyDataSearchDetails: {},
    statusPharmacyRelatedSearch: false,
    pharmacyHospitalizationDetails: {},
    pharmacyFieldDetails: {},
    pharmacyVisitFindingDetails: {},
    pharmacyGeneralRemarksDetails: {},
    loadingCasePharmacy: false,
    errorsCasePharmacy: {},
    statusPharmacyHospitalizationDetails:false
}


const CasePharmacyReducer = (state = initialCaseState, action) => {
    console.log("action", action.payload);
    switch (action.type) {
        case "ADD_CASE_PHARMACY_DATA_SEARCH_PENDING":
        case "ADD_CASE_PHARMACY_HOSPITALIZATION_PENDING":
        case "ADD_CASE_PHARMACY_FIELD_PENDING":
        case "ADD_CASE_PHARMACY_VISIT_FINDING_PENDING":
        case "ADD_CASE_PHARMACY_GENERAL_REMARKS_PENDING":
            return { 
                ...state, 
                loading: true, 
                statusPharmacyRelatedSearch: false,
                statusPharmacyHospitalizationDetails:false,
            };

        case "ADD_CASE_PHARMACY_DATA_SEARCH_FULFILLED":
            return {
                ...state,
                loading: false,
                pharmacyDataSearchDetails: action.payload,
                statusPharmacyRelatedSearch: true,
                errorsCasePharmacy: {}
            };
        case "ADD_CASE_PHARMACY_HOSPITALIZATION_FULFILLED":
            return {
                ...state,
                loading: false,
                statusPharmacyHospitalizationDetails:true,
                pharmacyHospitalizationDetails: action.payload,
                errorsCasePharmacy: {}
            };
        case "ADD_CASE_PHARMACY_FIELD_FULFILLED":
            return {
                ...state,
                loading: false,
                pharmacyFieldDetails: action.payload,
                errorsCasePharmacy: {}
            };
        case "ADD_CASE_PHARMACY_VISIT_FINDING_FULFILLED":
            return {
                ...state,
                loading: false,
                pharmacyVisitFindingDetails: action.payload,
                errorsCasePharmacy: {}
            };

        case "ADD_CASE_PHARMACY_GENERAL_REMARKS_FULFILLED":
            return {
                ...state,
                loading: false,
                pharmacyGeneralRemarksDetails: action.payload,
                errorsCasePharmacy: {}
            };

        case "ADD_CASE_PHARMACY_DATA_SEARCH_REJECTED":
        case "ADD_CASE_PHARMACY_HOSPITALIZATION_REJECTED":
        case "ADD_CASE_PHARMACY_FIELD_REJECTED":
        case "ADD_CASE_PHARMACY_VISIT_FINDING_REJECTED":
        case "ADD_CASE_PHARMACY_GENERAL_REMARKS_REJECTED":
            return {
                ...state,
                loading: false,
                errorsCasePharmacy: action.payload,
                statusPharmacyHospitalizationDetails:false,
            };

        case "RESET_PHARMACY_DATA_SEARCH_DETAILS":
            return {
                ...state,
                pharmacyDataSearchDetails: {},
                statusPharmacyRelatedSearch:false
            };

        case "RESET_PHARMACY_HOSPITALIZATION_DETAILS":
            return {
                ...state,
                pharmacyHospitalizationDetails: {},
                statusPharmacyHospitalizationDetails:false,
            };

        case "RESET_PHARMACY_FIELD_DETAILS":
            return {
                ...state,
                pharmacyFieldDetails: {}
            };

        case "RESET_PHARMACY_VISIT_FINDING_DETAILS":
            return {
                ...state,
                pharmacyVisitFindingDetails: {}
            };

        case "RESET_PHARMACY_GENERAL_REMARKS_DETAILS":
            return {
                ...state,
                pharmacyGeneralRemarksDetails: {}
            };

        case "RESET_CASE_PHARMACY_ERRORS":
            return {
                ...state,
                errorsCasePharmacy: {}
            };

        default:
            return state;
    }
}

export default CasePharmacyReducer;